
import {
  commaDecimalToDecimal,
  formatByCountry
} from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { DimensionPerKoliData } from "@/domain/entities/Cargo";
import { Options, prop, Vue } from "vue-class-component";
import PopupDimensionPerKoli from "@/app/ui/views/cargo/booking-cargo/components/popup-dimension-per-koli.vue";
import { CargoController } from "@/app/ui/controllers/CargoController";

class Props {
  isEdit = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  components: {
    PopupDimensionPerKoli
  }
})
export default class DimensionPerKoliComponent extends Vue.with(Props) {
  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  formatNumberToString(value: number) {
    return formatByCountry(value, { type: "weight", country: this.countryCode });
  }

  editDimensionPerKoli = false;

  get summary(): DimensionPerKoliData {
    if (this.isEdit) {
      return CargoController.dimensionPerKoliDataEdit;
    } else {
      return CargoController.dimensionPerKoliData;
    }
  }

  onEdit() {
    this.editDimensionPerKoli = true;
  }

  get isSttUpdated(): boolean {
    return CargoController.isSttUpdated;
  }

  get errorSummary(): string {
    if (this.summary.totalPieces > 15) {
      CargoController.setErrorMaxPieces(true);
      return "Total koli melebihi batas";
    }

    if (
      this.summary.actualGrossWeight > 400 ||
      this.summary.actualVolumeWeight > 400
    ) {
      CargoController.setErrorMaxGrossWeight(true);
      return "Total berat melebihi batas";
    }

    CargoController.setErrorMaxPieces(false);
    CargoController.setErrorMaxGrossWeight(false);
    return "";
  }
}
